import { defineComponent, useAttrs, computed, createElementBlock, openBlock, normalizeStyle, normalizeClass, createElementVNode, withDirectives, renderSlot, mergeProps, createCommentVNode, toDisplayString, unref, vShow } from "vue";
import { S as SIZES } from "./chunks/p-btn.types.js";
import { useInputClasses } from "./useInputClasses.js";
import { _ as _export_sfc } from "./chunks/_plugin-vue_export-helper.js";
const _hoisted_1 = ["aria-checked", "data-testid"];
const _hoisted_2 = ["checked"];
const TOGGLE_SIZES = {
  sm: `w-7 h-4 after:top-[2px] after:left-[2px] after:h-3 after:w-3`,
  md: `w-11 h-6 after:top-[2px] after:left-[2px] after:h-5 after:w-5`,
  lg: `w-[52px] h-7 after:top-0.5 after:left-[2px] after:h-6 after:w-6`
};
const TOGGLE_CLASSES = [
  "shadow-inner-toggle",
  "bg-p-gray-30",
  "transition-all",
  "duration-300",
  "rounded-full",
  "peer-checked:after:translate-x-full",
  "peer-checked:after:border-white",
  "after:content-['']",
  "after:absolute",
  "after:bg-white",
  "after:rounded-full",
  "after:transition-all",
  "after:duration-300",
  "peer-checked:bg-primary",
  "peer-disabled:bg-p-blue-10",
  "peer-disabled:after:border-p-blue-10"
].join(" ");
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    name: "PToggle",
    inheritAttrs: false
  },
  __name: "p-toggle",
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    },
    errorMsg: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "md",
      validator(value) {
        return SIZES.includes(value);
      }
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const props = __props;
    const allAttrs = useAttrs();
    const { labelClasses, errorMsgClasses } = useInputClasses(props);
    const toggleClasses = computed(() => {
      const base = `${TOGGLE_CLASSES} ${TOGGLE_SIZES[props.size]}`;
      const res = props.errorMsg ? `${base} border border-on-error` : base;
      return res;
    });
    const toggleLabelClasses = computed(() => {
      return `${labelClasses.value.replace("mb-1", "")} ml-2`;
    });
    const attrs = computed(() => {
      const { style: style2, class: classes, "data-testid": dataTestId, ...rest } = allAttrs;
      return rest;
    });
    const style = computed(() => {
      return allAttrs.style;
    });
    const change = (e) => {
      const target = e.target;
      emit("update:modelValue", target.checked);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["inline-flex flex-col", _ctx.$attrs.class]),
        style: normalizeStyle(style.value),
        role: "switch",
        "aria-checked": __props.modelValue ? "true" : "false",
        "data-testid": _ctx.$attrs["data-testid"]
      }, [
        createElementVNode("label", {
          class: normalizeClass(["relative inline-flex items-center", { "cursor-pointer": !_ctx.$attrs.disabled }])
        }, [
          createElementVNode("input", mergeProps({
            type: "checkbox",
            checked: __props.modelValue,
            class: "peer sr-only"
          }, { ...attrs.value, input: () => {
          }, onChange: change }), null, 16, _hoisted_2),
          createElementVNode("div", {
            class: normalizeClass(toggleClasses.value)
          }, null, 2),
          renderSlot(_ctx.$slots, "label", {
            label: __props.label,
            labelClasses: toggleLabelClasses.value
          }, () => [
            __props.label ? (openBlock(), createElementBlock("span", {
              key: 0,
              class: normalizeClass(toggleLabelClasses.value)
            }, toDisplayString(__props.label), 3)) : createCommentVNode("", true)
          ], true)
        ], 2),
        withDirectives(createElementVNode("div", {
          class: normalizeClass(unref(errorMsgClasses))
        }, toDisplayString(__props.errorMsg), 3), [
          [vShow, __props.errorMsg]
        ])
      ], 14, _hoisted_1);
    };
  }
});
const pToggle = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-be9ecb77"]]);
export {
  pToggle as default
};
